
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Comprendre le Multicanal: Définition, Avantages et Stratégies pour Votre Entreprise",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition multicanal, une stratégie marketing essentielle dans le monde numérique pour optimiser votre relation client et augmenter vos ventes.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comprendre le Multicanal: Définition, Avantages et Stratégies pour Votre Entreprise",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition multicanal, une stratégie marketing essentielle dans le monde numérique pour optimiser votre relation client et augmenter vos ventes.",
        },
      ],
    };
  },
};
